import React, { Component } from 'react';
import './PassengersMobile.css';
import PassengersListWrapper from '../../passengersList/PassengersListWrapper';
import RouteTabs from '../../routeTabs/RouteTabs';
import PassengersController from '../PassengersScreenController';
import EditPassengerDialog from './EditPassengerDialog';
import PassengersMobileProps from './PassengersMobileProps';
import Dictionary from '../../../model/Dictionary';

export default class PassengersMobileScreen extends Component {
  static propTypes = PassengersMobileProps;

  constructor (props) {
    super(props);
    this.state = { editOpened: false, selectedPassenger: undefined };
    this.openEditPassenger = PassengersController.openEditPassenger.bind(this);
    this.closeEditPassenger = PassengersController.closeEditPassenger.bind(this);
  }

  render () {
    const { routeId, routes, selectedRoute, selectedTrip, toggleRoutes } = this.props;
    const { editOpened, selectedPassenger } = this.state;

    return (
      <div className='passengers-mobile' id='mobile-container'>
        <h1>{Dictionary.passengers.title}</h1>
        <RouteTabs
          centered
          showDate
          routes={routes}
          selectedTrip={selectedTrip}
          selectedRoute={selectedRoute}
          toggleRoutes={toggleRoutes}
          TabContent={
            <PassengersListWrapper
              routeId={routeId}
              onRowAction={this.openEditPassenger}
              selectable
              addNew
            />
          }
        />
        <EditPassengerDialog
          editOpened={editOpened}
          handleClose={this.closeEditPassenger}
          selectedPassenger={selectedPassenger}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/passengers/mobile/PassengersMobileScreen.js